import axios from 'axios';
import qs from 'query-string';

import WizardSteps from '../pages/basket/wizard-steps';

const _axios = axios.create( {

} );

export const GET_BASKET_ITEMS = 'GET_BASKET_ITEMS';
export const ADD_ITEM = 'ADD_ITEM';
export const UPDATE_ITEM = 'UPDATE_ITEM';
export const DELETE_ITEM = 'DELETE_ITEM';
export const SET_WIZARD_STEP = 'SET_WIZARD_STEP';
export const ORDER_FAILED = 'ORDER_FAILED';


export const addItem = ( catalogNumber, qty ) => async dispatch => {
        try {
            const params = {
                catalogNumber,
                qty
            };
            const response = await _axios.post( '/api/v1/basket/add', qs.stringify( params ) );

            dispatch( { type: ADD_ITEM, payload: response.data } );
        } catch ( error ) {
            console.error( error );
        }
    };


export const updateItem = ( catalogNumber, qty ) => async dispatch => {
        try {
            const params = {
                catalogNumber,
                qty
            };
            const response = await _axios.post( '/api/v1/basket/update', qs.stringify( params ) );
            dispatch( { type: UPDATE_ITEM, payload: response.data } );
        } catch ( error ) {
            console.error( error );
        }
    };


export const deleteItem = ( catalogNumber ) => async dispatch => {
        try {
            const params = {
                catalogNumber
            };
            const response = await _axios.post( '/api/v1/basket/delete', qs.stringify( params ) );

            dispatch( { type: DELETE_ITEM, payload: catalogNumber } );
        } catch ( error ) {
            console.error( error );
        }
    };

export const createOrder = ( values ) => async dispatch => {
        try {
            dispatch( { type: SET_WIZARD_STEP, payload: WizardSteps.ORDER_PROCESSING } );
            const response = await _axios.post( '/api/v1/order/createOrder', qs.stringify( values ) );
            return true;
        } catch ( error ) {
            let code = error.response ? error.response.data.code : error.code;
            console.error( error );
            dispatch( { type: ORDER_FAILED, payload: code } );
            return false;
        }
    };

export const createPriceOffer = ( values ) => async dispatch => {
        try {
            dispatch( { type: SET_WIZARD_STEP, payload: WizardSteps.ORDER_PROCESSING } );

            const response = await _axios.post( '/api/v1/order/createPriceOffer', qs.stringify( values ) );
            return true;
        } catch ( error ) {
            let code = error.response ? error.response.data.code : error.code;
            console.error( error );
            dispatch( { type: ORDER_FAILED, payload: code } );
            return false;
        }
    };


export function setWizardStep( wizardStep ) {
    return {
        type: SET_WIZARD_STEP,
        payload: wizardStep
    };
}


    